export enum QUERY_NAME {
  fetchFAQSections = 'fetchFAQSections',
  fetchFAQSectionItems = 'fetchFAQSectionItems',
}
